import { atom } from 'jotai';

import type { Heidi2BookDemoContact, Heidi2OnboardingOutcome } from '@heidi/agents';

/**
 * Module-scoped rather than section-local because the dev-tools sheet unmounts
 * its content on close: the trigger sets these atoms and then closes the
 * sheet, and the always-mounted `Heidi2OnboardingDevHost` reads them.
 */
export const heidi2OnboardingDevOpenAtom = atom(false);
export const heidi2OnboardingDevLastOutcomeAtom = atom<Heidi2OnboardingOutcome | null>(
  null
);
export const heidi2OnboardingDevLastBookDemoAtom = atom<Heidi2BookDemoContact | null>(
  null
);
